import type { RootState } from '../index';

export const selectAccommodationProperty = (state: RootState) =>
  state.accommodation.property;

export const selectAccommodationProperties = (state: RootState) =>
  state.accommodation.properties;

export const selectSelectedBooking = (state: RootState) =>
  state.accommodation.selectedBooking;

export const selectSelectedGuest = (state: RootState) =>
  state.accommodation.selectedGuest;

export const selectAccommodationIsLoading = (state: RootState) =>
  state.accommodation.isLoading;

export const selectAccommodationError = (state: RootState) =>
  state.accommodation.error;
